























import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { mapState, mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import ClassifiedReportService from '~/services/report/classified/ClassifiedReportService'
import { defineComponent } from '@nuxtjs/composition-api'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CReportModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/modal/CReportModal.vue')
    ),
    ReportModalInfo: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/ReportModalInfo.vue')
    )
  },
  data: () => ({
    reportModalVisible: false,
    icons: {
      exclamationTriangle: faExclamationTriangle
    }
  }),
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      classifiedId: state => state.classifiedId
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      userIsOwner: 'isOwn'
    }),
    classifiedReportService() {
      return this.$dep(ClassifiedReportService)
    }
  },
  methods: {
    showModal() {
      this.reportModalVisible = true
    },
    handleVisibilityChange(newVisibilityState) {
      const delayOnHide = newVisibilityState
        ? (fn: Function) => fn()
        : (fn: Function) => setTimeout(fn, 500) // Delay for disappearance animation to complete

      delayOnHide(() => {
        this.reportModalVisible = newVisibilityState
      })
    }
  }
})
